import styled from 'styled-components';
import ds from 'designsystem';
import PanelGroup from 'blocks/PanelGroup/index';

/* eslint react/destructuring-assignment: "off" */

const StyledPanelHeading = styled(PanelGroup.Heading)`
    display: flex;
    justify-content: space-between;
    padding: ${ds.get('metrics.s')} 0;
    border-bottom: ${props => (props['data-isactive'] ? 'none' : `1px solid ${ds.brand('background')}`)};
`;

export default StyledPanelHeading;


// WEBPACK FOOTER //
// ./src/kentico-blocks/Accordion/PanelGroup/StyledPanelHeading.jsx